(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsManageDomainController',TabObjectsManageDomainController);

    TabObjectsManageDomainController.$inject = ['$uibModalInstance', '$state', '$scope', 'entity', 'TabObjects', 'TabDomains', 'TabFleets'];

    function TabObjectsManageDomainController($uibModalInstance, $state, $scope, entity, TabObjects, TabDomains, TabFleets) {
        var vm = this;

        vm.tabObjects = entity;
        vm.domains = TabDomains.query({
            page: 0,
            size: 100
        });

        vm.domain = null;
        vm.fleet = null;
        vm.styleDomain = "col-md-11 col-xs-12";
        vm.disabledFleet = false;

        vm.selectDomain = function() {
            vm.styleDomain = vm.domain == null ? "col-md-11 col-xs-12" : "col-md-6 col-xs-12";
            TabFleets.domains({id: vm.domain.id}, onSuccessFleet, onErrorFleet);
        }

        function onSuccessFleet(data) {
            if(data.length === 0) {
                vm.disabledFleet = true;
            } else {
                vm.fleets = data;
                vm.disabledFleet = false;
            }
        }

        function onErrorFleet() {}

        vm.manangeDomain = function (){
            vm.isSaving = true;
            vm.tabObjects.fleet = vm.fleet;
            TabObjects.update(vm.tabObjects, onSaveSuccess, onSaveError);
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectsUpdate', result);
            vm.isSaving = false;
            $uibModalInstance.close(true);
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
